// extracted by mini-css-extract-plugin
export default {"tunnelContainer":"SpaceTunnel_tunnelContainer__mHYTD"};